import React from "react";
import PropTypes from "prop-types";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Divider,
} from "@mui/material";
import { MdWarning } from "react-icons/md";
import { IoClose } from "react-icons/io5";
import SoftTypography from '../../components/SoftTypography';
import SuiButton from "../../components/SoftButton";
import { archiveBatch } from "../../axios-client";

function DeleteBatchDialog({isModalOpen, handleCloseModal, batchId, batchName, refreshBatches, setNotification}) {


    const handleDelete = async () => {        
    try {

        await archiveBatch(batchId);
        setNotification({
            show: true,
            snackbarMessage: "Batch archived successfully",
            severity: "success",
        });

        refreshBatches();
        handleCloseModal();
    } catch (err) {
        setNotification({
            show: true,
            snackbarMessage: "Failed to archive batch",
            severity: "error",
        });
        console.error("Error archiving batch:", err);
    }
    };

  return (
    <Dialog
      open={isModalOpen}
      maxWidth="xs"
      fullWidth
      PaperProps={{ style: { borderRadius: 15 } }}
    >
      <DialogTitle sx={{ display: "flex", alignItems: "center", fontSize: "1.4rem" }}>
        Delete Batch
        <IoClose
          onClick={handleCloseModal}
          style={{
            position: "absolute",
            right: 8,
            top: 8,
            cursor: "pointer",
          }}
        />
      </DialogTitle>

      <Divider />

      <DialogContent sx={{ textAlign: "center", p: 2 }}>
        <MdWarning size={80} style={{ color: "#D32F2F" }} />

        <SoftTypography variant="h6" sx={{ mt: 2 }}>
          Are you sure you want to delete this batch?
        </SoftTypography>

        <SoftTypography variant="body2" color="secondary" sx={{ mt: 1 }}>
          “{batchName}”
        </SoftTypography>
      </DialogContent>

      <Divider />

      <DialogActions>
        <SuiButton variant="gradient" color="secondary" onClick={handleCloseModal}>
          Cancel
        </SuiButton>
        <SuiButton
          variant="contained"
          color="error"
          onClick={handleDelete}
          sx={{ ml: 1 }}
        >
          Delete
        </SuiButton>
      </DialogActions>
    </Dialog>
  );
}

DeleteBatchDialog.propTypes = {
  isModalOpen: PropTypes.bool,
  handleCloseModal: PropTypes.func,
  batchId: PropTypes.number,
  batchName: PropTypes.string,
  refreshBatches: PropTypes.func,
  setNotification: PropTypes.func,
};

export default DeleteBatchDialog;